// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 

const firebaseConfig = {

  apiKey: "AIzaSyDYU8vfNtvMzg6hWNWEj-NhV607-kJf40I",

  authDomain: "strat-edge-b0a5a.firebaseapp.com",

  projectId: "strat-edge-b0a5a",

  storageBucket: "strat-edge-b0a5a.firebasestorage.app",

  messagingSenderId: "37466707317",

  appId: "1:37466707317:web:b978c74e8cf0d5f54e6f3c",

  measurementId: "G-BPM285Q62N"

};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
